import ContributionProvider from './ContributionProvider';

window.tnew.page.initialize = ({ contributionTypes, addedContributionId, addedContributionAmount }) => {
  const contributionProvider = new ContributionProvider(contributionTypes, addedContributionId, addedContributionAmount);
  contributionProvider.listen();
};



// WEBPACK FOOTER //
// ./V7/products/contribution/contribution.js